import { ThreadModel } from './thread-model';
import { Serializable } from '../../../core/models/serializable';

export class ThreadWithPreviewsModel
  implements Serializable<ThreadWithPreviewsModel>
{
  fromObject(object: any): ThreadWithPreviewsModel {
    Object.assign(this, object);
    this.items = {};

    if (object && object.items) {
      var keys = Object.keys(object.items);
      keys.forEach((k) => {
        if (!(k in this.items)) this.items[k] = [];

        let objThreads = object.items[k];
        objThreads.forEach((t) => {
          let tmp = new ThreadModel();
          tmp = tmp.fromObject(t);
          this.items[k].push(tmp);
        });
      });
    }
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public items: { [objectId: number]: ThreadModel[] };
}
